module.exports = __webpack_public_path__ + "img/sign.4b76a5c0.png";